import {useForm} from 'react-hook-form'
import {RenderField} from "../../../components/forms/HookFormFields";
import {yupResolver} from '@hookform/resolvers/yup'
import * as yup from 'yup'


export const ChangeGSXTokenForm = ({onSubmit}: any) => {
    const gsxAuthTokenURL = "https://login-partner-connect.apple.com"
    const changeGSXTokenSchema = yup.object().shape({
        gsx_token: yup
            .string()
            .test(
                'required',
                'This field is required.',
                (value: string | undefined) => !!value?.trim(),
            ),
    })

    const {
        register,
        handleSubmit,
        reset,
        formState: {errors, isSubmitting, isDirty},
    } = useForm({
        resolver: yupResolver(changeGSXTokenSchema),
        defaultValues: {
            gsx_token: '',
        },
    })

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <RenderField
                label="New GSX Token"
                error={errors.gsx_token?.message}
                registerProps={register('gsx_token')}
            />

            <div className="d-flex justify-content-end gap-2 mt-3">
                <button
                    type="button"
                    className="btn btn-outline-secondary"
                    disabled={!isDirty || isSubmitting}
                    onClick={() => reset()}
                >
                    Reset
                </button>

                <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={isSubmitting}
                >
                    {isSubmitting ? 'Saving...' : 'Submit'}
                </button>
            </div>

            <p style={{padding: '10px 0px'}} className="text-end">
                <a
                    rel="noopener noreferrer"
                    className="text-dark btn-sm"
                    href={gsxAuthTokenURL}
                    target="_blank"
                >
                    Click Here to Retrieve GSX Auth Token
                </a>
            </p>
        </form>
    )
}
